var Model = require('../Model');

var containsLocation = Object.create(Model);

containsLocation.name = 'containsLocation';
containsLocation['@class'] = 'containsLocation';
containsLocation.url = 'containsLocation';
containsLocation.isEdge = true;
containsLocation.fields = {
  equipmentRecord:{
    default: null,
    hidden: true
  },
  linkedLocation: {
    default: null,
    hidden: true
  },
};

module.exports = containsLocation;